// Client-side download for CSV bodies fetched through the authenticated api
// client (a plain link would not carry the devise-token headers).
export const downloadCsvFile = (content: string, filename: string) => {
  const url = URL.createObjectURL(
    new Blob([content], { type: "text/csv;charset=utf-8;" }),
  );

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();

  // Revoke after the browser has started the download — a synchronous revoke
  // can abort it in some engines.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
